import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "solutions container" }
const _hoisted_2 = { class: "row w-75 mx-auto my-5" }
const _hoisted_3 = { class: "row w-75 mx-auto" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "video" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Products = _resolveComponent("Products")!
  const _component_Features = _resolveComponent("Features")!
  const _component_Title = _resolveComponent("Title")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Products)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Features)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Title, {
        title: "影片介紹",
        subtitle: "影片介紹"
      }),
      _hoisted_5
    ])
  ]))
}